import { useMemo } from 'react'
import { FloatingContext, ElementProps } from '@floating-ui/react'

// this hook utilizes floating-ui's ability to create custom hook behavior
// https://floating-ui.com/docs/useCustomLogic
// it will close the floating element if a button within the body of the floating element is clicked (specifically for the AddBadge.tsx behavior)
export const useFloatingDismiss = (
  { onOpenChange, events }: FloatingContext,
  { enabled }: { enabled: boolean }
): ElementProps => {
  return useMemo(
    () => ({
      floating: {
        // React.HTMLProps
        onClick(e) {
          if (
            (enabled &&
              e.target instanceof HTMLImageElement &&
              e.target.getAttribute('data-id') === 'add-badge') ||
            (enabled && e.target instanceof HTMLButtonElement)
          ) {
            // emitting a closing event in case other floating-ui hooks depend on this
            events.emit('dismiss', {
              type: 'escapeKey',
              data: {
                returnFocus: { preventScroll: false },
              },
            })
            // set the state of the floating-ui element to closed
            onOpenChange(false)
          }
        },
      },
    }),
    [enabled, events, onOpenChange]
  )
}
